import React from 'react';
import {IQuote} from "../../../../../../../app/interfaces/quote/IQuote";
import {useTranslation} from "react-i18next";

type ADRFieldProps = {
    quote: IQuote;
}

const spanStyle: React.CSSProperties = {
    color: 'white',
    backgroundColor: 'var(--red-color)',
    padding: '2px 10px',
    borderRadius: '24px'
}

const AdrField: React.FC<ADRFieldProps> = ({
                                               quote
                                           }) => {
    const {t} = useTranslation();

    if (quote.adr.length <= 0) {
        return null;
    }

    return (
        <div className={'details-box-item-field-value adr-value'}>
            <span style={spanStyle}>
                {t("quote.form.adr")}
            </span>
        </div>
    );
};

export default AdrField;
